import * as api from '../api/batchprocessing';
import { makeApiActionCreatorV3 } from '@actions/utils';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';

const namespace = 'QUEUE';

export const FETCH_BATCH_PROCESSINGS = createRequestTypes(
  `${namespace}/FETCH_BATCH_PROCESSINGS`,
);

export const fetchBatchProcessings = makeApiActionCreatorV3(
  api.fetchBatchProcessings,
  FETCH_BATCH_PROCESSINGS[START],
  FETCH_BATCH_PROCESSINGS[SUCCESS],
  FETCH_BATCH_PROCESSINGS[ERROR],
);

export const FETCH_BATCH_PROCESSING = createRequestTypes(
  `${namespace}/FETCH_BATCH_PROCESSING`,
);

export const fetchBatchProcessing = makeApiActionCreatorV3(
  api.fetchBatchProcessing,
  FETCH_BATCH_PROCESSING[START],
  FETCH_BATCH_PROCESSING[SUCCESS],
  FETCH_BATCH_PROCESSING[ERROR],
);

export const CREATE_PROCESSING = createRequestTypes(
  `${namespace}/CREATE_PROCESSING`,
);

export const createProcessing = makeApiActionCreatorV3(
  api.createProcessing,
  CREATE_PROCESSING[START],
  CREATE_PROCESSING[SUCCESS],
  CREATE_PROCESSING[ERROR],
);

export const FETCH_BARCODE_FORMATS = createRequestTypes(
  `${namespace}/FETCH_BARCODE_FORMATS`,
);

export const fetchBarcodeFormats = makeApiActionCreatorV3(
  api.fetchBarcodeFormats,
  FETCH_BARCODE_FORMATS[START],
  FETCH_BARCODE_FORMATS[SUCCESS],
  FETCH_BARCODE_FORMATS[ERROR],
);

export const FIND_LINKED_OBJECT = createRequestTypes(
  `${namespace}/FIND_LINKED_OBJECT`,
);

export const findLinkedObject = makeApiActionCreatorV3(
  api.findLinkedObject,
  FIND_LINKED_OBJECT[START],
  FIND_LINKED_OBJECT[SUCCESS],
  FIND_LINKED_OBJECT[ERROR],
);

export const CREATE_WORK_ITEMS = createRequestTypes(
  `${namespace}/CREATE_WORK_ITEMS`,
);

export const createWorkItems = makeApiActionCreatorV3(
  api.createWorkItems,
  CREATE_WORK_ITEMS[START],
  CREATE_WORK_ITEMS[SUCCESS],
  CREATE_WORK_ITEMS[ERROR],
);

export const FETCH_COMPLETED_ITEMS = createRequestTypes(
  `${namespace}/FETCH_COMPLETED_ITEMS`,
);

export const fetchCompletedItems = makeApiActionCreatorV3(
  api.fetchCompletedItems,
  FETCH_COMPLETED_ITEMS[START],
  FETCH_COMPLETED_ITEMS[SUCCESS],
  FETCH_COMPLETED_ITEMS[ERROR],
);

export const FETCH_PENDING_ITEMS = createRequestTypes(
  `${namespace}/FETCH_PENDING_ITEMS`,
);

export const fetchPendingItems = makeApiActionCreatorV3(
  api.fetchPendingItems,
  FETCH_PENDING_ITEMS[START],
  FETCH_PENDING_ITEMS[SUCCESS],
  FETCH_PENDING_ITEMS[ERROR],
);

export const FETCH_ERROR_ITEMS = createRequestTypes(
  `${namespace}/FETCH_ERROR_ITEMS`,
);

export const fetchErrorItems = makeApiActionCreatorV3(
  api.fetchErrorItems,
  FETCH_ERROR_ITEMS[START],
  FETCH_ERROR_ITEMS[SUCCESS],
  FETCH_ERROR_ITEMS[ERROR],
);

export const CLOSE_PROCESS = createRequestTypes(`${namespace}/CLOSE_PROCESS`);

export const closeProcess = makeApiActionCreatorV3(
  api.closeProcess,
  CLOSE_PROCESS[START],
  CLOSE_PROCESS[SUCCESS],
  CLOSE_PROCESS[ERROR],
);

export const VALIDATE_LINKED_OBJECTS = createRequestTypes(
  `${namespace}/VALIDATE_LINKED_OBJECTS`,
);

export const validateLinkedObjects = makeApiActionCreatorV3(
  api.validateLinkedObjects,
  VALIDATE_LINKED_OBJECTS[START],
  VALIDATE_LINKED_OBJECTS[SUCCESS],
  VALIDATE_LINKED_OBJECTS[ERROR],
);

export const UPDATE_TRANSACTION = createRequestTypes(
  `${namespace}/UPDATE_TRANSACTION`,
);

export const updateTransaction = makeApiActionCreatorV3(
  api.updateTransaction,
  UPDATE_TRANSACTION[START],
  UPDATE_TRANSACTION[SUCCESS],
  UPDATE_TRANSACTION[ERROR],
);

export const GENERATE_PRE_SIGNED_URL = createRequestTypes(
  `${namespace}/GENERATE_PRE_SIGNED_URL`,
);

export const generatePreSignedURL = makeApiActionCreatorV3(
  api.generatePreSignedURL,
  GENERATE_PRE_SIGNED_URL[START],
  GENERATE_PRE_SIGNED_URL[SUCCESS],
  GENERATE_PRE_SIGNED_URL[ERROR],
);
